// @flow

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import {
  TREE,
  REPORTS,
} from '../constants'

export default traverse([TREE, REPORTS], {default: {}})
